import { CommonModule, NgIf } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild, computed, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TextBoxModule } from '@progress/kendo-angular-inputs';
import { KENDO_LISTVIEW, ListViewComponent } from '@progress/kendo-angular-listview';
import { SVGIcon, searchIcon } from '@progress/kendo-svg-icons';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ControlResizerService } from '../../../../../../services/framework';
import { AuthorizationService, RequestUserPermission } from '../../../../../modules/fwcore';
import { Company } from '../../../models';
import { AdminService } from '../../../services';
import { KENDO_SVGICON } from '@progress/kendo-angular-icons';
import { IsgSizerDirective } from '../../../../prob/directives/isg-sizer.directive';

@Component({
  selector: 'app-company-list',
  standalone: true,
  imports: [CommonModule, TextBoxModule, FormsModule, IsgSizerDirective, KENDO_SVGICON, KENDO_LISTVIEW],
  templateUrl: './company-list.component.html',
  styleUrl: './company-list.component.scss'
})
export class CompanyListComponent implements OnInit, OnDestroy {

  // ---------------- New Input/Outputs ----------------

  public heightControl = input(300);

  public showToolbar = input(false);


  public selected = output<Company | null>();


  // ---------------- Public methods ----------------

  public selectedItem?: Company | null;

  public clearSelection() {
    this.selectedItem = null;
    this.compListView.focus(undefined);
  }

  //----------------- State properties  ------------------
  //protected compListView = viewChild<ListViewComponent>("companyList");

  @ViewChild(ListViewComponent, { static: false })
  protected compListView!: ListViewComponent;

  protected loading: boolean = true;


  protected dataItems: Company[] = [];
  protected dataItemsFull: Company[] = [];

  protected destroy$ = new Subject();

  protected reqPerm: RequestUserPermission = {

  }

  protected startsWithSearch: string = "";

  public searchIcon: SVGIcon = searchIcon;

  /*-------------------------- Constructor  --------------------------*/

  constructor(
    public serviceAuth: AuthorizationService
    , protected router: Router
    , protected adminService: AdminService
  ) {
  }

  /*----------------------------------- ng  --------------------------*/

  ngOnInit(): void {
    this.getData();
  }

  ngOnDestroy(): void {

    this.destroy$.next();
    this.destroy$.complete();
  }

  /*--------------------------- event handlers  --------------------------*/

  protected onClickItemEvent(index: number, dataItem: Company, event: Event): void {

    let newSelection: Company = dataItem;
    event.stopPropagation();

    if (this.selectedItem == newSelection) {
      this.clearSelection();
      this.selected.emit(this.selectedItem);
    }
    else {
      this.selectedItem = newSelection;
      this.compListView.focus(index);
      this.selected.emit(this.selectedItem);
    }

  }

  /*--------------------------- internal functions  --------------------------*/

  protected onFilterChange(query: string): void {
    const normalizedQuery = query.toLowerCase();

    const filterExpession = (item: Company) =>
      item.name?.toLowerCase().indexOf(normalizedQuery) !== -1;

    this.dataItems = this.dataItemsFull.filter(filterExpession);
  }

  // ---------------- API Processing ----------------

  protected getData(): void {

    this.adminService.getAllCompanies()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {
          this.dataItemsFull = data;
          this.dataItems = data;
        }
      );
  }

}


